import React from 'react'
import styles from './ExperienceYears.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'

export const ExperienceYears = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    return (
        <div className={styles.wrapper}>
            <div>
                <FormTitle
                    formTitleText='業界の経験年数は何年ですか？'
                    dataViewLabel={dataViewLabel('EF_StepForm_経験年数')}
                    dataClickLabel={dataClickLabel('EF_StepForm_経験年数-戻る')}
                />
                <div className={styles.selectionWrapper}>
                    <ChoicesButton
                        imageSrc='/foodslaboEf/img/step2/experience1.png'
                        imageAlt='1年未満画像'
                        text='1年未満'
                        formKey={'experienceYears'}
                        formValue={'less_than_one_year'}
                        displayFormKey={'experienceYears'}
                        displayFormValue={'1年未満'}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_経験年数-1年未満'
                        )}
                    />
                    <ChoicesButton
                        imageSrc='/foodslaboEf/img/step2/experience2.png'
                        imageAlt='1~5年画像'
                        text='1~5年'
                        formKey={'experienceYears'}
                        formValue={'one_to_five_years'}
                        displayFormKey={'experienceYears'}
                        displayFormValue={'1~5年'}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_経験年数-1~5年'
                        )}
                    />
                    <ChoicesButton
                        imageSrc='/foodslaboEf/img/step2/experience3.png'
                        imageAlt='5~10年画像'
                        text='5~10年'
                        formKey={'experienceYears'}
                        formValue={'five_to_ten_years'}
                        displayFormKey={'experienceYears'}
                        displayFormValue={'5~10年'}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_経験年数-5~10年'
                        )}
                    />
                    <ChoicesButton
                        imageSrc='/foodslaboEf/img/step2/experience4.png'
                        imageAlt='10年以上画像'
                        text='10年以上'
                        formKey={'experienceYears'}
                        formValue={'more_than_ten_years'}
                        displayFormKey={'experienceYears'}
                        displayFormValue={'10年以上'}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_経験年数-10年以上'
                        )}
                    />
                </div>
            </div>
        </div>
    )
}
